import { render, staticRenderFns } from "./UserEntityDetails.vue?vue&type=template&id=cd9cc658"
import script from "./UserEntityDetails.vue?vue&type=script&lang=js"
export * from "./UserEntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9cc658')) {
      api.createRecord('cd9cc658', component.options)
    } else {
      api.reload('cd9cc658', component.options)
    }
    module.hot.accept("./UserEntityDetails.vue?vue&type=template&id=cd9cc658", function () {
      api.rerender('cd9cc658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserEntityDetails.vue"
export default component.exports